import React, { useEffect, useState } from "react";
import { Message, TickSquare } from "iconsax-react";
import Swal from "sweetalert2";
import MobileLayout from "../../components/MobileLayout";
import { useAuth } from "../../hooks/auth";
import {
  getCommunityLaunchSubscription,
  subscribeToCommunityLaunch,
  unsubscribeFromCommunityLaunch,
} from "../../services/communityLaunchService";

import { Container, CommunityCard, SubscribeBox, CheckboxRow } from "./styles";

const Community: React.FC = () => {
  const { user } = useAuth();
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }

    async function checkSubscription() {
      if (!user?.uid) return;
      try {
        const sub = await getCommunityLaunchSubscription(user.uid);
        setSubscribed(!!sub);
      } catch (error) {
        console.error("Error checking subscription:", error);
      } finally {
        setLoading(false);
      }
    }

    checkSubscription();
  }, [user]);

  const handleToggleSubscription = async () => {
    if (!user?.uid || !user?.email || toggling) return;

    setToggling(true);
    try {
      if (subscribed) {
        await unsubscribeFromCommunityLaunch(user.uid);
        setSubscribed(false);
        Swal.fire({
          icon: "info",
          title: "Inscrição removida",
          text: "Você não será mais notificado sobre o lançamento.",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        await subscribeToCommunityLaunch(user.uid, user.email);
        setSubscribed(true);
        Swal.fire({
          icon: "success",
          title: "Inscrição realizada!",
          text: "Avisaremos você assim que a comunidade for lançada!",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error toggling subscription:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível processar sua solicitação.",
      });
    } finally {
      setToggling(false);
    }
  };

  return (
    <MobileLayout headerTitle="Comunidade" headerType="private">
      <Container>
        <CommunityCard>
          <div className="icon-box">
            <Message size={48} variant="Bold" />
          </div>

          <h2>Comunidade</h2>
          <div className="badge">Em Breve</div>

          <p>
            Estamos preparando um espaço exclusivo para você interagir com
            outros estudantes, tirar dúvidas e compartilhar conhecimentos em
            Libras!
          </p>

          {user?.uid && user?.email && !loading && (
            <SubscribeBox>
              <CheckboxRow
                $active={subscribed}
                onClick={handleToggleSubscription}
              >
                <div className="checkbox">
                  {subscribed && <TickSquare size={16} variant="Bold" />}
                </div>
                <span>
                  Quero ser notificado quando a comunidade for lançada
                </span>
              </CheckboxRow>
            </SubscribeBox>
          )}

          {!user && (
            <p
              style={{
                fontSize: "14px",
                fontStyle: "italic",
                marginTop: "20px",
              }}
            >
              Faça login para poder se inscrever nas notificações de lançamento.
            </p>
          )}
        </CommunityCard>
      </Container>
    </MobileLayout>
  );
};

export default Community;
